import { ActivityDefinitionType } from '@/models/enums';

export default class EnumState {
  public activityDefinitionTypes?: ActivityDefinitionType[];
}
